import { render, staticRenderFns } from "./MailPreviewDialog.vue?vue&type=template&id=59797877&"
import script from "./MailPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./MailPreviewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports